(function () {
  if (!document.documentElement.classList.contains('eveloria-turmeric-landing')) return;
  if (!/\/pages\/turmeric-brightening\/?/.test(window.location.pathname)) return;

  var PID = '8957783769345';

  function clearArBlockers() {
    try {
      delete window.__AR_VARIABLE_INJECT;
    } catch (e) {
      window.__AR_VARIABLE_INJECT = 0;
    }
    try {
      delete window.__AR_CORE_SNIPPET;
    } catch (e) {
      window.__AR_CORE_SNIPPET = false;
    }
  }

  window.Shopify = window.Shopify || {};
  window.Shopify.product = { id: Number(PID), handle: 'turmeric-pads' };

  clearArBlockers();

  var guardAttempts = 0;
  var injectGuard = window.setInterval(function () {
    if (window.__AR_VARIABLE_INJECT || window.__AR_CORE_SNIPPET) clearArBlockers();
    if (
      document.querySelector(
        '.ev-turmeric-reviews .alr-wh-comp-summary, .ev-turmeric-reviews .alr-wh-comp-review'
      )
    ) {
      window.clearInterval(injectGuard);
      return;
    }
    if (++guardAttempts > 200) window.clearInterval(injectGuard);
  }, 100);

  var style = document.createElement('style');
  style.textContent =
    'html.eveloria-turmeric-landing [id*="__product_reviews_footer"]{display:block!important;visibility:visible!important}' +
    'html.eveloria-turmeric-landing [id*="__product_reviews"]:not([id*="__product_reviews_footer"]):not(#ev-lp-reviews-root){display:none!important}' +
    'html.eveloria-turmeric-landing #ev-lp-reviews-root{display:none!important}';
  document.head.appendChild(style);
})();
